



































































import { Component, Mixins } from 'vue-property-decorator'
import axios from 'axios'
import moment from 'moment-timezone'
import SnackbarService from '@/services/snackbar-service'

@Component({
  components: {},
})
export default class HistoryView extends Mixins(SnackbarService) {
  history: any[] = []

  search = ''

  deleteHistoryDialogIsOpen = false

  headers = [
    { text: 'Tiempo', value: 'datetime' },
    { text: 'Finca', value: 'farm_id' },
    { text: 'Numero de vaca', value: 'cow_number' },
    { text: 'Action', value: 'action' },
    { text: 'Mensage', value: 'message' },
    { text: 'User', value: 'user_id' },
  ]

  created() {
    this.$store.state.loading = true
    this.$store.state.showAppbar = true
    this.$store.state.changeBack = '/home'
    this.$store.state.navbarText = 'Ultimas cambias'
    this.getHistory()
  }

  getHistory() {
    axios
      .get(`/history`)
      .then((res: any) => {
        this.history = res.data
        this.history.forEach((h: any) => {
          h.datetime = moment
            .utc(h.datetime, 'YYYY-MM-DDThh:mm:ss')
            .tz('America/Bogota')
            .format('YYYY-MM-DD hh:mm:ss')
        })
      })
      .catch(error => {
        if (error.response && error.response.status >= 300) {
          this.notify({ text: `Server error. ${error}` })
        }
      })
      .finally(() => {
        this.$store.state.loading = false
      })
  }

  deleteHistory() {
    this.$store.state.loading = true
    axios
      .delete(`/history`)
      .then(() => {
        this.getHistory()
      })
      .catch(error => {
        let errorMessage
        if (error.response && error.response.status >= 300) {
          errorMessage = `Server error. ${error}`
        } else {
          errorMessage = 'Error eliminar historia'
        }
        this.notify({ text: errorMessage })
        this.$store.state.loading = false
      })
      .finally(() => {
        this.deleteHistoryDialogIsOpen = false
      })
  }
}
